import {gql,TypedDocumentNode} from '@apollo/client';

interface Result {
    deletePackage: boolean,
}

interface Variables {
    deletePackageId: string,
}

export const DELETE_PACKAGE: TypedDocumentNode<Result, Variables> = gql`
    mutation DeletePackage($deletePackageId: Int!){
        deletePackage(id: $deletePackageId)
    }       
`
